import React from "react";

interface ErrorMessageProps {
  error?: any;
}

export default function ErrorMessage({ error }: ErrorMessageProps) {
  if (error && error.type) {
    switch (error.type) {
      case "required":
        return <p>This is required</p>;
      case "maxLength":
        return <p>Your name need maximum 20 characters</p>;
      case "pattern":
        return <p>Enter a valid email address</p>;
      default:
        return null;
    }
  }

  return null;
}